module.exports = __webpack_public_path__ + "img/8.a36db736.png";